
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { NewsletterResource } from 'app/models/NewsletterResource';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { NewsletterAddSubscriberService } from 'app/newsletter/newsletter-subscribers/newsletter-add-subscriber/newsletter-add-subscriber.service';
import { UtilsService } from "app/services/utils.service";
import { TagResource } from "app/models/TagResource";
@Component({
	selector: 'vbn-newsletter-add-subscriber',
	providers: [NewsletterAddSubscriberService],
	templateUrl: './newsletter-add-subscriber.component.html',
	styleUrls: ['./newsletter-add-subscriber.component.scss']
})
export class NewsletterAddSubscriberComponent implements OnInit {
	
	errorMessage: any;
	newsletterResource: NewsletterResource;
	saveErrors: boolean = false;
	correctEmail: boolean = false;
	noneSelected: boolean = true;
    tagListRO: TagResource[];
	tagListEN: TagResource[];
	tagListResourceRO: TagResource[];
	tagListResourceEN: TagResource[];
	tagError: boolean = false;
	currentLanguage = localStorage.getItem("vbn-language");
	checked: boolean;
	checkTagsRO: any;
	checkTagsEN: any;
	checkObject: any;
	@Output() closeFromEdit = new EventEmitter();
	@Input() receiveSubscriber: NewsletterResource;
	saveErrorsEmail: boolean = false;
	newEmail: string;
	userEmail: string;


	constructor(private fb: FormBuilder,
		private newsletterAddSubscriberService: NewsletterAddSubscriberService,
		private router: Router,
		private translate: TranslateService,
		private _notificationService: NotificationsService,
		private utilsService: UtilsService,
	) {
		this.newsletterResource = new NewsletterResource();
		// this.tagListRO = new Array();
		// this.tagListResourceRO = new Array();
		// this.tagListEN = new Array();
		// this.tagListResourceEN = new Array();
		this.newsletterResource = new NewsletterResource();
		//this.newsletterResource.tags = new Array();
		// this.checkTagsRO = new Array();
		// this.checkTagsEN = new Array();
	}

	addForm = this.fb.group({
		email: ['', [Validators.required, Validators.maxLength(100), Validators.email]],
	})

	ngOnInit() {
		this.userEmail = this.utilsService.currentUserEmail;
		//this.getAllActiveTagsRO('ro');
		//this.getAllActiveTagsEN('en');
		if (this.receiveSubscriber != null) {
			this.newsletterResource = this.receiveSubscriber;
			this.getNewsletterByEmail(this.newsletterResource.rid)
		}
	}

	save() {
		let semafor = false;
		if (!this.addForm.valid) {
			semafor = true
		}
		if (this.newsletterResource.email === "" || this.newsletterResource.email == undefined) {
			this.saveErrors = true
			semafor = true
		}
		// if (this.newsletterResource.tags.length == 0) {
		// 	this.tagError = true;
		// 	semafor = true
		// }
		let emailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!emailValid.test(String(this.newsletterResource.email).toLowerCase())) {
			semafor = true;
			this.saveErrorsEmail = true;
			observableForkJoin(
				this.translate.get('Incorrect email'),
				this.translate.get('Please write a correct email address!')
				).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			});
		} else {
			this.saveErrorsEmail = false;
		}
		if (semafor) {
			observableForkJoin(
				this.translate.get('Mising fields'),
				this.translate.get('Please fill out the fields!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})
			return;
		}
		this.newsletterResource.keepMyPersonalData = true;
		this.newsletterResource.agreeToReceiveNewsletters = true;
		if (this.newsletterResource.rid == null || this.newsletterResource.rid == undefined) {
			this.newsletterResource.userEmail = this.userEmail;
			this.newsletterAddSubscriberService.saveSubscriber(`admin/newsletter/addOrEdit`, this.newsletterResource).subscribe(
				body => {
					this.newsletterResource = body
					if (body.errorCode == 7007) {
						observableForkJoin(
							this.translate.get('Email in use'),
							this.translate.get('Please add a different email')
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						})
						return
					}
					this.goToSubscribersList();
				},
				error => console.log(error))
		} else {
			this.newsletterResource.newEmail = this.newEmail;
			this.newsletterResource.email = this.receiveSubscriber.email;
			console.log("!!!!!!", this.newsletterResource, this.receiveSubscriber.email)
			this.newsletterAddSubscriberService.saveSubscriber(`admin/newsletter/edit`, this.newsletterResource).subscribe(
				body => {
					this.newsletterResource = body
					this.closeFromEdit.emit(true)
				},
				error => console.log(error))
		}
	}

	goToSubscribersList() {
		if (this.receiveSubscriber != null) {
			this.closeFromEdit.emit(true)

		} else {
			this.router.navigateByUrl('/newsletter-subscribers');
		}
	}

	getNewsletterByEmail(email) {
		// this.newsletterAddSubscriberService.getNewsletter('admin/newsletter/getByEmail?email=' + email)
		this.newsletterAddSubscriberService.getNewsletter('admin/newsletter/get/' + email)
			.subscribe(
			response => {
				this.newsletterResource = response;
				//this.tagListResourceRO = this.tagListRO;
				this.checkEmail(this.newsletterResource.email);
					// for (let i = 0; i < this.tagListResourceRO.length; i++) {
					// 	let checkObject: any = {};
					// 	checkObject.check = false;
					// 	checkObject.rid = this.tagListResourceRO[i].rid;
					// 	let foundObj = this.newsletterResource.tags.find(s => s.rid == checkObject.rid);
					// 	if (foundObj != null)
					// 		checkObject.check = true;
					// 	this.checkTagsRO.push(checkObject)
					// }
					// this.tagListResourceEN = this.tagListEN;
					// for (let i = 0; i < this.tagListResourceEN.length; i++) {
					// 	let checkObject: any = {};
					// 	checkObject.check = false;
					// 	checkObject.rid = this.tagListResourceEN[i].rid;
					// 	let foundObj = this.newsletterResource.tags.find(s => s.rid == checkObject.rid);
					// 	if (foundObj != null)
					// 		checkObject.check = true;
					// 	this.checkTagsEN.push(checkObject)
					// }
					// let a = this.checkTagsRO.find(t => !t.check);
					// let isAllChecked = ( a === undefined);
					// let c = this.checkTagsEN.find(t => !t.check);
					// let isAllChecked3 = ( c === undefined);
					
					// if (isAllChecked && isAllChecked3) {
					// 	this.noneSelected = false;
					// } else {
					// 	this.noneSelected = true;
					// }
			}
			)
	}

	getAllActiveTagsRO(language) {
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.currentLanguage = localStorage.getItem("vbn-language");
		});
		if (this.receiveSubscriber == null) {
			this.tagListRO = new Array<TagResource>();
		}
		this.newsletterAddSubscriberService.getAllTags('admin/tags/getAllActive?language=' + language)
			.subscribe(
			response => {
				// Object.assign(this.tagListResourceRO, response);
				this.tagListRO = response.tagListResource;
				if (this.receiveSubscriber == null) {
					if (this.tagListRO == null) {
						this.tagListResourceRO = []
					} else {
						this.tagListResourceRO = this.tagListRO;
					}
					this.checkTagsRO = new Array();
					for (let i = 0; i < this.tagListResourceRO.length; i++) {
						this.checkObject = {};
						this.checkObject.check = false;
						this.checkObject.rid = this.tagListResourceRO[i].rid;
						this.checkTagsRO.push(this.checkObject)
					}
					this.checkObject = {};
				}
			},
			error => this.errorMessage = <any>error
			);
	}

	getAllActiveTagsEN(language) {
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.currentLanguage = localStorage.getItem("vbn-language");
		});
		if (this.receiveSubscriber == null) {
			this.tagListEN = new Array<TagResource>();
		}
		this.newsletterAddSubscriberService.getAllTags('admin/tags/getAllActive?language=' + language)
			.subscribe(
			response => {
				// Object.assign(this.tagListResourceEN, response);
				this.tagListEN = response.tagListResource;
				if (this.receiveSubscriber == null) {
					if (this.tagListEN == null) {
						this.tagListResourceEN = []
					} else {
						this.tagListResourceEN = this.tagListEN;
					}
					this.checkTagsEN = new Array();
					for (let i = 0; i < this.tagListResourceEN.length; i++) {
						this.checkObject = {};
						this.checkObject.check = false;
						this.checkObject.rid = this.tagListResourceEN[i].rid;
						this.checkTagsEN.push(this.checkObject)
					}
					this.checkObject = {};
				}
			},
			error => this.errorMessage = <any>error
			);
	}


	// updateCheckedOptionsTags(tags: TagResource, event) {
	// 	if (event.target.checked) {
	// 		this.newsletterResource.tags.push(tags);
	// 		this.tagError = false;
	// 		for(let i = 0; i < this.checkTagsRO.length; i++){
	// 			if(tags.rid == this.checkTagsRO[i].rid){
	// 				this.checkTagsRO[i].check = true;
	// 			}
	// 		}
	// 		for(let i = 0; i < this.checkTagsEN.length; i++){
	// 			if(tags.rid == this.checkTagsEN[i].rid){
	// 				this.checkTagsEN[i].check = true;
	// 			}
	// 		}
	// 	} else {
	// 		for(let i = 0; i < this.checkTagsRO.length; i++){
	// 			if(tags.rid == this.checkTagsRO[i].rid){
	// 				this.checkTagsRO[i].check = false;
	// 			}
	// 		}
	// 		for(let i = 0; i < this.checkTagsEN.length; i++){
	// 			if(tags.rid == this.checkTagsEN[i].rid){
	// 				this.checkTagsEN[i].check = false;
	// 			}
	// 		}
	// 		for (let i = 0; i < this.newsletterResource.tags.length; i++) {
	// 			if (tags.rid == this.newsletterResource.tags[i].rid) {
	// 				this.newsletterResource.tags.splice(i, 1);
	// 				if (this.newsletterResource.tags.length == 0) {
	// 					this.tagError = true;
	// 				}
	// 				return
	// 			}
	// 		}
	// 	}
	// 	console.log("eveniment : {}, locatie : {}", event.target.checked, tags);
	// }

	// checkAllTags() {
	// 	this.checked = true;
	// 	this.newsletterResource.tags = new Array();
	// 	for (let i = 0; i < this.checkTagsRO.length; i++) {
	// 		this.checkTagsRO[i].check = true;
	// 		if (this.checkTagsRO[i].check == true) {
	// 			let tag = new TagResource();
	// 			tag.rid = this.checkTagsRO[i].rid;
	// 			this.newsletterResource.tags.push(tag);
	// 		}
	// 	}
	// 	for (let i = 0; i < this.checkTagsEN.length; i++) {
	// 		this.checkTagsEN[i].check = true;
	// 		if (this.checkTagsEN[i].check == true) {
	// 			let tag = new TagResource();
	// 			tag.rid = this.checkTagsEN[i].rid;
	// 			this.newsletterResource.tags.push(tag);
	// 		}
	// 	}
	// 	this.noneSelected = false;
	// }

	// uncheckAllTags() {
	// 	this.checked = false;
	// 	for (let i = 0; i < this.checkTagsRO.length; i++) {
	// 		this.checkTagsRO[i].check = false;
	// 	}
	// 	for (let i = 0; i < this.checkTagsEN.length; i++) {
	// 		this.checkTagsEN[i].check = false;
	// 	}
	// 	this.newsletterResource.tags = new Array();
	// 	this.noneSelected = true;
	// }

	checkEmail(email) {
		console.log("adasda", email)
		this.newEmail = email;
		if (email != undefined && email != "" && email != null) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (re.test(String(email).toLowerCase())) {
			this.saveErrorsEmail = false
		} else {
			this.saveErrorsEmail = true;
			observableForkJoin(
				this.translate.get('Incorrect email'),
				this.translate.get('Please write a correct email address!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			});
		}
		}
	}

}
